var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PostContentTags post-content-tags"},_vm._l((_vm.data.tags),function(tag){return _c('router-link',{key:tag.slug,staticClass:"post-content-tags__tag",attrs:{"to":tag.route,"aria-label":`Click on ${tag.name} tag`}},[_c('span',{staticClass:"post-content-tags__tag-hash"},[_vm._v("#")]),_vm._v(" "+_vm._s(tag.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }